export default __webpack_public_path__ + "static/media/code-06.1a78b87a.svg";